import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingInFrontImage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h16v2.5H0zm4.5 4.5h7v7h-7zm-2 0H0V7h2.5zM0 9h2.5v2.5H0zm16-4.5h-2.5V7H16zM13.5 9H16v2.5h-2.5zm2.5 4.5H0V16h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingInFrontImage
